import { useState } from "react";
import {
  registrationInfoStore,
  useRegistration,
} from "../../libs/registration/registration.hook";
import { Checkbox } from "../form/styles/checkbox";
import { TermsCheckboxWrapper, TermsCompStyle } from "./terms.comp.styles";

export const TermsV2Comp = ({ isMonthly }: { isMonthly: boolean }) => {
  const { registrationInfo, setRegistrationInfo } = useRegistration();

  return (
    <TermsCompStyle>
      <h3>Liability Waiver: *</h3>
      <p>
        In order to use the studio spaces and equipment at ColourInspired, the
        student must be enrolled in a current class, (S)he must also participate
        in the review and acceptance of studio use, safety and cleaning
        procedures as laid out by the instructor & ColourInspired studio
        manager, and obey all posted signage. If the student does not comply
        with the studio policies the student/parent acknowledges that an
        accident might occur.
      </p>
      <p>
        Completion of this form releases ColourInspired and its officers from
        any responsibility of accidents that may occur within the studio or
        while using ColourInspired equipment, including, but not limited to
        handling of the heat guns, glue guns, exacto knives, wood burner, use of
        epoxy, solvents, inks and paints. The student/parent also agrees that
        the student will not consume any art materials such as: glue, paint,
        glitter, epoxy, clay, chalk, etc. and will use art materials according
        to ColourInsipred guidelines only.
      </p>
      <p>
        The student/parent agrees that they have provided all the true and
        necessary information about any allergies or medications the student
        might have or needs to use and agrees for ColourInspired to provide
        first medical assistance in case a reaction might occur.
      </p>
      <TermsCheckboxWrapper>
        <Checkbox
          checked={registrationInfo.liabilitySigned}
          onChange={() =>
            setRegistrationInfo({
              liabilitySigned: !registrationInfo.liabilitySigned,
            })
          }
          type="checkbox"
        />{" "}
        I have read and understand the studio use & liability waiver
      </TermsCheckboxWrapper>

      <h3>Payments Information: *</h3>
      <p>
        It is understood and agreed that by signing up your child(ren) for our
        services, you agree to pay the specified amount
        {isMonthly ? " on a monthly basis" : ""}.{" "}
        {isMonthly
          ? `This
        includes the understanding that fees are to be paid consistently each
        month, regardless of any temporary closures, including but not limited
        to holidays, as part of the agreed terms of engagement.`
          : ""}
      </p>
      {isMonthly ? (
        <p>
          In case a student misses a class due to sickness or vacation, you will
          be able to schedule a make-up class on a different day. You are
          allowed to reschedule 1 art class per month per student.
        </p>
      ) : (
        <p>
          In case a participant misses the activity, you will be able to use it
          as a credit for other services provided by the studio.
        </p>
      )}
      <TermsCheckboxWrapper>
        <Checkbox
          checked={registrationInfo.paymentSigned}
          onChange={() =>
            setRegistrationInfo({
              paymentSigned: !registrationInfo.paymentSigned,
            })
          }
          type="checkbox"
        />{" "}
        I have read and understand the above Payments Information
      </TermsCheckboxWrapper>

      {isMonthly && (
        <>
          <h3>$50 Cancellation fee: *</h3>
          <p>
            I agree to pay $50 fee in case I cancel my subscription before the
            end of the academic year (June 2025)
          </p>
          <TermsCheckboxWrapper>
            <Checkbox
              checked={registrationInfo.cancellationSigned}
              onChange={() =>
                setRegistrationInfo({
                  cancellationSigned: !registrationInfo.cancellationSigned,
                })
              }
              type="checkbox"
            />{" "}
            I have read and understand the above Cancellation fee Information
          </TermsCheckboxWrapper>
        </>
      )}

      <h3>Return Policy: *</h3>
      <p>
        No refund will be given for an art class, program or workshop if notice
        of withdrawal is not received at least one week in advance of class
        start date.
      </p>
      <TermsCheckboxWrapper>
        <Checkbox
          checked={registrationInfo.returnsSigned}
          onChange={() =>
            setRegistrationInfo({
              returnsSigned: !registrationInfo.returnsSigned,
            })
          }
          type="checkbox"
        />{" "}
        I have read and understand the above Return Policy
      </TermsCheckboxWrapper>

      <h3>Photo Release: *</h3>
      <p>
        I grant to ColourInspired, its representatives and employees the right
        to take photographs of me/my child and my/my child’s work in connection
        with the Education Program, Events and Studio Rental. I authorize
        ColourInspired, its assignments and transferees to copyright, use and
        publish the same in print and/or electronically. I agree that
        ColourInspired may use such photographs of me/my child with or without
        my name and for any lawful purpose, including such purposes as
        publicity, illustration, advertising, and Web content.
      </p>
      <TermsCheckboxWrapper>
        <Checkbox
          checked={registrationInfo.photoReleaseSigned}
          onChange={() =>
            setRegistrationInfo({
              photoReleaseSigned: !registrationInfo.photoReleaseSigned,
            })
          }
          type="checkbox"
        />{" "}
        I have read and understand the above Photo Release
      </TermsCheckboxWrapper>

      <h3>Allergies or Medical Conditions: *</h3>
      <p>
        Colour Inspired Studio advises all program registrants suffering from
        allergenic medical conditions to register in art classes at their own
        risk. Colour Inspired Academy uses a lot of materials such as: paint,
        clay, glue, epoxy resin and more that might cause allergic reactions.
        Colour Inspired Studio, instructors, contractors and volunteers make no
        representations and will accept no liability regarding presence or
        absence of all allergens at facilities where art programs take place.
      </p>
      <TermsCheckboxWrapper>
        <Checkbox
          checked={registrationInfo.medicalSigned}
          onChange={() =>
            setRegistrationInfo({
              medicalSigned: !registrationInfo.medicalSigned,
            })
          }
          type="checkbox"
        />{" "}
        I have read and understand the above Allergies or Medical Conditions
      </TermsCheckboxWrapper>

      <h3>Code of Conduct *</h3>
      <p>
        ColourInspired is committed to maintaining an environment of courtesy,
        safety, respect and proper conduct among all associated with the
        organization, including students, instructors, staff, interns,
        volunteers, studio renters, exhibiting artists and visitors. Some
        guidelines are set out below, with additional policies distributed in
        other documents for specific uses of our studios. Failure to adhere to
        the guidelines below, as well as in any additional document issued by
        ColourInspired, may lead to the individual’s membership, access
        volunteer, board or employment status being terminated or being asked to
        leave the premises and not return to ColourInspired studios, events or
        workshops. Any criminal conduct will be reported to the police and
        prosecuted.
      </p>
      <p>
        ColourInspired does not discriminate on the basis of race, color,
        national or ethnic origin, ancestry, age, religion or religious creed,
        disability, sex or gender, gender identity and/or expression, sexual
        orientation, military or veteran status, genetic information, or any
        other characteristic protected under applicable federal or local law.
        Nor does it tolerate behavior from others on ColourInspired’s premise
        that might violate such laws.
      </p>
      <p>
        ColourInspired has a zero-tolerance policy against threats or
        intimidation, stalking, bullying or verbal abuse, gestures of a violent
        or inappropriate nature, sexual harassment, physical assault, or any
        other behavior that creates a hostile environment.
      </p>
      <p>
        When using the studio, ColourInspired requires that individuals be kind
        and courteous to everyone, and follow the instructions issued by staff,
        teachers and studio assistants. Disruptive behavior that distracts from
        learning, art-making or the center’s day-to-day operations is not
        allowed.
      </p>
      <p>
        ColourInspired requires respect of the space by following all posted
        signage and verbal instruction. All safety rules and COVID disinfection
        rules MUST be followed, and it is recommended that studio users learn
        the potential hazards of all materials and processes used.
      </p>
      <p>
        ● All students should familiarize themselves with locations and
        instructions for emergency showers, eye washes, first aid kits, fire
        extinguishers and emergency exits, as well as the proper disposal of all
        art materials and proper use of disinfectants.
      </p>
      <p>
        ● ColouInspired is committed to making a continued effort to minimize
        contribution to pollution and waste, implementing sustainable practices
        whenever possible by both recycling and minimizing usage of
        petroleum-based products.
      </p>
      <TermsCheckboxWrapper>
        <Checkbox
          checked={registrationInfo.codeSigned}
          onChange={() =>
            setRegistrationInfo({
              codeSigned: !registrationInfo.codeSigned,
            })
          }
          type="checkbox"
        />{" "}
        I have read and understand the Code of Conduct
      </TermsCheckboxWrapper>
    </TermsCompStyle>
  );
};
